import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import ReactDOM from "react-dom"
import "../../css/Loading.css"
export default function Loading(){
    return ReactDOM.createPortal(
        <div className="overlay">
            <Box sx={{ display: 'flex'}}>
                <CircularProgress sx={{color:"white"}}/>
            </Box>
        </div>,
        document.body
    )
}